import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import { FeatureItem, FeaturesList } from './styled';

export const Safer: FC = () => (
  <FeaturesList>
    <FeatureItem>
      <FuelIcon name="user-frame" iconStyle="filled" size="medium" />
      <FuelTypography size="body-lg" weight="medium" color="neutral-default">
        <FuelTypography displayInline weight="bold">
          Reconhecimento facial:
        </FuelTypography>{' '}
        validamos a identidade do motorista que você negocia usando tecnologia bancária.
      </FuelTypography>
    </FeatureItem>
    <FeatureItem>
      <FuelIcon name="double-check" iconStyle="filled" size="medium" />
      <FuelTypography size="body-lg" weight="medium" color="neutral-default">
        <FuelTypography displayInline weight="bold">
          Motorista verificado:
        </FuelTypography>{' '}
        fazemos uma validação rigorosa de toda documentação do motorista, utilizando bases do governo.
      </FuelTypography>
    </FeatureItem>
  </FeaturesList>
);
